import { captureInitialShowHandoff } from "./showViewNavigation";

// Keep this as main.tsx's first import: App creates its router at module load,
// and telemetry must never observe the incoming bearer-ticket fragment.
captureInitialShowHandoff(window.location, window.history);
